import { useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import UploadTrayView from "../common/UploadTrayView";
import {
  cancelRedactionUpload,
  clearFinishedRedactionUploads,
  getRedactionUploads,
  subscribeRedactionUploads,
} from "../../services/redactionUploadService";

/**
 * The bottom-right progress tray for PDFs being uploaded and redacted (the same
 * tray Files, forms and Investigations use). Mounted once in the Dashboard so it
 * keeps showing as the officer moves between pages.
 */
const RedactionUploadTray: React.FC = () => {
  const items = useSyncExternalStore(subscribeRedactionUploads, getRedactionUploads);
  const navigate = useNavigate();
  return (
    <UploadTrayView
      items={items.map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
        progress: i.progress,
        error: i.error,
        doneLabel: i.after,
        onOpen: i.openPath ? () => navigate(i.openPath!) : undefined,
      }))}
      onClearFinished={clearFinishedRedactionUploads}
      activeHint="Keep this tab open until the upload finishes. After that the PII is identified on our servers."
      finishedHint="Your documents are ready. Click a name to review the redactions."
      finishedVerb="Finished"
      onCancel={cancelRedactionUpload}
    />
  );
};

export default RedactionUploadTray;
